export default {
  logo: {
    height: 100,
    width: 100,
  },
  box: {
    backgroundColor: 'background.default',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'center'
  },
  progressContainer: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center'
  },
  Link: {
    alignItems: 'center',
    display: 'flex'
  }
};
